<template>
    <b-overlay
        class="h-100"
        :show="status === 'loading' && !editMode"
    >
        <div class="card-header align-items-start">
            <div class="card-group-title">
                <b-card-title>
                    {{ $t('org.billing.Region Cost') }}
                </b-card-title>

            </div>
            <b-card-actions-container
                v-if="!editMode && ((thisMonthRegions && thisMonthRegions.length) || (lastMonthRegions && lastMonthRegions.length)) && !viewTypeIsMobile"
                class="card-actions-container"
                :open="isVisible"
                @card:collapse="triggerCollapse"
            />
        </div>
        <template
            v-if="(thisMonthRegions && thisMonthRegions.length) || (lastMonthRegions && lastMonthRegions.length)"
        >
            <div class="position-relative" :style="{ height: 'calc(100% - 78px)'}">
                <RegionCardChart
                    ref="container"
                    :svg="svg"
                    :thisMonthRegions="thisMonthRegions"
                    :lastMonthRegions="lastMonthRegions"
                    @resize:svg="handleResize"
                    @detail-layer="showDetailModal"
                >
                </RegionCardChart>
            </div>
            <div
                ref="REF_COLLAPSE"
                :style="collapseResponsiveStyle"
            >
                <RegionCardTable
                    v-show="!editMode && isVisible"
                    :thisMonthRegions="thisMonthRegions"
                    :lastMonthRegions="lastMonthRegions"
                    @detail-layer="showDetailModal"
                ></RegionCardTable>
            </div>
        </template>
        <template v-else>
            <div class="d-flex justify-content-center align-items-center flex-column text-center pt-5">
                <SVGEmptyIcon/>
                <span>{{ $t('org.dashboard.No data') }}</span>
            </div>
        </template>
    </b-overlay>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import RegionCardChart from './RegionCardChart'
import RegionCardTable from './RegionCardTable'
import { computed, ref, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
import useDashboard from '@/composables/useDashboard'
import useDashboardRender from '@/composables/useDashboardRender'
export default {
    components: {
        BCardActionsContainer,
        RegionCardChart,
        RegionCardTable,
        SVGEmptyIcon
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { isOpen } = toRefs(props)
        const { viewType } = useDashboardRender()
        const viewTypeIsMobile = computed(() => viewType.value === 'mobile')
        const collapseResponsiveStyle = {
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%'
        }
        const isVisible = ref(false)
        const tableHeight = ref(null)
        const REF_COLLAPSE = ref(null)
        const triggerCollapse = (status) => {
            context.emit('action:showTable', { component: 'summary-card-regions', status })
        }
        watch(isOpen, (value, oldValue) => {
            isVisible.value = value
            vm.$nextTick(() => {
                tableHeight.value = value ? vm.$refs['REF_COLLAPSE'].offsetHeight : 0
                handleResize()
            })
        })
        const store = vm.$store
        const {
            getSummaryRegions
        } = useDashboard()
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])
        const [status, regionsCostData] = getSummaryRegions(currentParams.value)
        const svg = ref({
            width: 0,
            height: 0,
            paddingL: 1.7 * 14,
            paddingR: 1.7 * 14
        })
        const thisMonthRegions = computed(() => regionsCostData.value && regionsCostData.value.thisMonthRegions)
        const lastMonthRegions = computed(() => regionsCostData.value && regionsCostData.value.lastMonthRegions)
        const showDetailModal = (region) => {
            if (region.toLowerCase() !== 'etc') {
                context.emit('modal:showDetail', { region })
            }
        }
        const container = ref(null)
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth - svg.value.paddingL - svg.value.paddingR
                svg.value.height = container.value.$el.clientHeight - 77 - 14 - tableHeight.value
            }
        }
        watch(currentParams, (value, oldValue) => {
            getSummaryRegions(value)
        }, {
            deep: true
        })
        return {
            REF_COLLAPSE,
            status,
            svg,
            container,
            showDetailModal,
            handleResize,
            thisMonthRegions,
            lastMonthRegions,
            isVisible,
            triggerCollapse,
            collapseResponsiveStyle,
            viewTypeIsMobile
        }
    }
}
</script>

<style>
#containerRegionChart text.shadow {
    text-shadow: #000 2px 2px 10px
}
#containerRegionChart tspan.shadow {
    text-shadow: #000 2px 2px 10px
}
</style>
